import mitt from "mitt";

const bus = mitt(); // no need to declare event types
export default bus;
